/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbClasseRemarqueGridDto } from './FcbClasseRemarqueGridDto';
import {
    FcbClasseRemarqueGridDtoFromJSON,
    FcbClasseRemarqueGridDtoFromJSONTyped,
    FcbClasseRemarqueGridDtoToJSON,
} from './FcbClasseRemarqueGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbClasseRemarqueGridDtoPaginatedResults
 */
export interface FcbClasseRemarqueGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbClasseRemarqueGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbClasseRemarqueGridDto>}
     * @memberof FcbClasseRemarqueGridDtoPaginatedResults
     */
    results?: Array<FcbClasseRemarqueGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbClasseRemarqueGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbClasseRemarqueGridDtoPaginatedResults interface.
 */
export function instanceOfFcbClasseRemarqueGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbClasseRemarqueGridDtoPaginatedResultsFromJSON(json: any): FcbClasseRemarqueGridDtoPaginatedResults {
    return FcbClasseRemarqueGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbClasseRemarqueGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbClasseRemarqueGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbClasseRemarqueGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbClasseRemarqueGridDtoPaginatedResultsToJSON(value?: FcbClasseRemarqueGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbClasseRemarqueGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

